// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileUrlsResponseDto
 */
export interface IFileUrlsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IFileUrlsResponseDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IFileUrlsResponseDto
     */
    s3_url: string;
    /**
     * 
     * @type {string}
     * @memberof IFileUrlsResponseDto
     */
    thumbnail_url?: string;
}

/**
 * Check if a given object implements the IFileUrlsResponseDto interface.
 */
export function instanceOfIFileUrlsResponseDto(value: object): value is IFileUrlsResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('s3_url' in value) || value['s3_url'] === undefined) return false;
    return true;
}

export function IFileUrlsResponseDtoFromJSON(json: any): IFileUrlsResponseDto {
    return IFileUrlsResponseDtoFromJSONTyped(json, false);
}

export function IFileUrlsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileUrlsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        's3_url': json['s3_url'],
        'thumbnail_url': json['thumbnail_url'] == null ? undefined : json['thumbnail_url'],
    };
}

export function IFileUrlsResponseDtoToJSON(json: any): IFileUrlsResponseDto {
    return IFileUrlsResponseDtoToJSONTyped(json, false);
}

export function IFileUrlsResponseDtoToJSONTyped(value?: IFileUrlsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        's3_url': value['s3_url'],
        'thumbnail_url': value['thumbnail_url'],
    };
}

